import { Route, Redirect } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

import useUserStore from 'src/stores/user';
import useSessionStore from 'src/stores/session';
import { ROUTES_URL } from 'src/constants/routes';
import AppRouteLoader from 'src/components/Loading/AppRouteLoader';

import type { RouteProps } from 'react-router-dom';

interface IProtectedRoute extends RouteProps {
    path: string;
    noCheckIsApproved?: boolean;
}

export default function BeginWorkProtectedRoute({ path, ...otherProps }: IProtectedRoute) {
    const { isOnboardingCompleted } = useUserStore(({ isOnboardingCompleted }) => ({
        isOnboardingCompleted,
    }));
    const { getUserSessionRequiredData, hasSessionSnapshot } = useSessionStore(
        ({ getUserSessionRequiredData, hasSessionSnapshot }) => ({
            getUserSessionRequiredData,
            hasSessionSnapshot,
        })
    );
    const [isChecking, setIsChecking] = useState(!hasSessionSnapshot);
    const hasRequestedRef = useRef(false);

    useEffect(() => {
        if (hasSessionSnapshot) {
            setIsChecking(false);
            return;
        }

        if (hasRequestedRef.current) {
            return;
        }

        hasRequestedRef.current = true;
        console.log('🔄 [BeginWorkProtectedRoute] Данные в сторе отсутствуют, запрашиваем...');
        setIsChecking(true);
        getUserSessionRequiredData()
            .then((data) => {
                console.log('✅ [BeginWorkProtectedRoute] Снапшот получен:', {
                    is_onboarding_completed: data?.user?.is_onboarding_completed,
                    onboarding_step: data?.user?.onboarding_step,
                });
            })
            .catch((error) => {
                console.error('❌ [BeginWorkProtectedRoute] Ошибка загрузки данных:', error);
            })
            .finally(() => {
                setIsChecking(false);
            });
    }, [getUserSessionRequiredData, hasSessionSnapshot]);

    // Не показываем редирект пока проверяем данные
    if (isChecking) {
        console.log('⏳ [BeginWorkProtectedRoute] Проверка данных, ждем...');
        return <AppRouteLoader />;
    }

    // Если онбординг завершен - перенаправляем на Feed
    console.log('🔍 [BeginWorkProtectedRoute] Проверка статуса онбординга:', isOnboardingCompleted);
    if (isOnboardingCompleted) {
        console.log('🚀 [BeginWorkProtectedRoute] Онбординг завершен, перенаправляем на /feed');
        return <Redirect to={ROUTES_URL.FEED} />;
    }

    // Разрешаем переход на любой шаг BeginWork, пока онбординг не завершён

    return (
        <Route
            path={path}
            {...otherProps}
        />
    );
}
